
import { supabase } from "@/integrations/supabase/client";

/**
 * Log Claude API interactions to the database
 * NOTE: This is only used for fallback scenarios or client-side errors now.
 * Primary logging is done in the Edge Functions themselves.
 */
export const logClaudeApiInteraction = async (
  gameId: string | null,
  roundNumber: number | null,
  requestType: 'word_options' | 'proximity',
  input: any,
  finalJson?: any,
  error?: any,
  statusCode?: number,
  startTime?: number,
  fallbackUsed: boolean = false,
  fallbackReason: string = '',
  claudePrompt?: string,
  fullClaudeResponse?: string
) => {
  try {
    // Only log from the client side if this was a fallback scenario or an error
    // that couldn't be logged by the Edge Function
    if (!fallbackUsed && !error) {
      console.log(`Skipping client-side logging for ${requestType} - already logged by Edge Function`);
      return;
    }
    
    // Calculate duration if startTime was provided
    const endTime = Date.now();
    const duration = startTime ? endTime - startTime : null;
    
    // Prepare data for logging
    const logData = {
      game_id: gameId || null,
      round_number: roundNumber || null,
      request_type: requestType,
      response_timestamp: new Date().toISOString(),
      duration_ms: duration,
      input: input,
      final_json: finalJson || null,
      error_message: error ? (error.message || JSON.stringify(error)) : null,
      status_code: statusCode || null,
      fallback_used: fallbackUsed,
      fallback_reason: fallbackReason || null,
      claude_prompt: claudePrompt || null,
      full_claude_response: fullClaudeResponse || null
    };
    
    // Log to console for immediate feedback
    console.log(`Logging Claude API ${requestType} interaction (client-side fallback):`, {
      gameId, 
      roundNumber,
      duration,
      statusCode,
      errorMessage: logData.error_message?.substring(0, 100),
      fallbackUsed,
      fallbackReason,
      promptLength: claudePrompt ? claudePrompt.length : 0,
      responseLength: fullClaudeResponse ? fullClaudeResponse.length : 0
    });
    
    // Insert log into database
    const { error: insertError } = await supabase
      .from('claude_api_logs')
      .insert(logData);
      
    if (insertError) {
      console.error('Error logging Claude API interaction:', insertError);
    } else {
      console.log('Successfully logged Claude API interaction from client side');
    }
  } catch (logError) {
    // Don't let logging errors affect the main functionality
    console.error('Error in logClaudeApiInteraction:', logError);
  }
};
